import { SDK, ServerOptions } from '@commercetools/frontend-sdk';
import { AmplienceContentTypePaginated } from 'shared/types/amplience/Amplience';
import {
  GetContentByDeliveryKey,
  GetContentById,
  GetContentListByContentType,
} from 'sdk/composable-commerce/types/actions/AmplienceActions';
import { GetContentTypeByPagination } from 'sdk/composable-commerce/types/queries/AmplienceQueries';
import { ComposableCommerceEvents } from '../../types/events/ComposableCommerceEvents';

export type AmplienceActions = {
  getContentByDeliveryKey: GetContentByDeliveryKey;
  getContentById: GetContentById;
  getContentListByContentType: GetContentListByContentType;
};

export const getAmplienceActions = (sdk: SDK<ComposableCommerceEvents>): AmplienceActions => {
  return {
    getContentByDeliveryKey: async (
      deliveryKey: string,
      options: {
        parallel?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction({
        actionName: 'amplience/getContentByDeliveryKey',
        query: { deliveryKey },
        parallel: options.parallel,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
      });

      return response;
    },

    getContentById: async (
      id: string,
      options: {
        parallel?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction({
        actionName: 'amplience/getContentById',
        query: { id },
        parallel: options.parallel,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
      });

      return response;
    },

    getContentListByContentType: async (
      query: GetContentTypeByPagination,
      options: {
        parallel?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const { contentType, limit, nextCursor } = query;
      const response = await sdk.callAction<AmplienceContentTypePaginated>({
        actionName: 'amplience/getContentList',
        query: { contentType, limit: limit ?? 10, nextCursor: nextCursor ?? '' },
        parallel: options.parallel,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
      });

      return response;
    },
  };
};
